export const scrollMixin = {
  data() {
    return {
      imageVisible: false,
      handleScroll: null,
    };
  },
  watch: {
    imageVisible(nvl) {
      if (nvl) {
        window.removeEventListener("scroll", this.handleScroll);
      }
    },
  },
  created() {
    this.handleScroll = () => this.checkScroll();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.$nextTick(() => {
      this.handleScroll();
    });
  },
  methods: {
    checkScroll(value = 2 / 3) {
      const element = this.$el.querySelector(".content");
      const elTop = element.getBoundingClientRect().top;
      const visible = elTop < window.innerHeight * value;

      if (!this.imageVisible && visible) {
        this.imageVisible = true;
      }
    },
  },
};
